import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CommsService } from '../comms/comms.service';
import { ConfigService } from '../config/config.service';
import { NoteService } from '../note/note.service';
import { CookieService } from 'ngx-cookie-service';
import { DataService } from '../data/data.service';
import { DisplayService } from '../display/display.service';
import { environment } from '../../../environments/environment';
import { ValidationService } from '../validation/validation.service';
import { TabService } from '../tab/tab.service';
import { SettingsService } from '../settings/settings.service';
import { DataTableService } from '../dataTable/dataTable.service';
import _ from 'lodash';
import { localStorageKeys } from '../../constants';
import { EnvService } from '../../../config/env.service';

@Injectable()
export class UserService {

	dataObj = 'user';
	objRoot = 'user';
	dataConfig = {};
	tableConfig = {};
	actions = [];
	actionsForAll = [];

	uploadDataObj = 'userupload';
	uploadPageSize = 5;

	acceptDataObj = 'useraccept';
	acceptDataConfig: any = {};

	removeDataObj = 'userremove';
	removeDataConfig = {};

	errorDataObj = 'usererror';
	successDataObj = 'usersuccess';
	showFailedUsers = false;
	showSuccessUsers = false;

	env = environment;
	username = '';
	supplierId = '';
	token = '';
	refreshToken = '';
	availablePersonas = [];
	selectedPersona = '';
	persona = '';
	org = '';
	cookies = {};
	displayPrivacyNotice = false;
	agreedForPrivacy = false;
	showRemoveModal = false;
	showAddUsersModal = false;
	expiringUsers = [];
	fileUploadedUsers = [];
	fileUploadedInvalidUsers = [];
	email = '';
	files;
	fileUploadMessage = '';
	fileUploadSuccessMessage = '';
	isManualAdd = true;
	public isResetPassword: boolean;
	isForgotPassword: boolean;
	private emailPattern: string;
	private validRoles: Array<string> = [];
	private showReleaseNotes = false;

	tabsData = {
		tabs: [
			{
				prop: 'login',
				name: 'Login',
				active: true,
				notPersona: [],
				cached: false,
				listTab: false,
				statusTab: false,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}
		],
		// need update isAllTab if the tab order is changed
		listTabs: [
			{
				prop: 'all',
				name: 'All',
				active: false,
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'expiring',
				name: 'Expiring',
				active: false,
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}
		],
		// tabs in add users modal (data-modal-add-users)
		uploadTabs: [
			{
				prop: 'valid',
				name: 'Valid',
				active: false,
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'upload',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'invalid',
				name: 'Invalid',
				active: false,
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'upload',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}
		]
	};

	constructor(
		private router: Router,
		private commsService: CommsService,
		private configService: ConfigService,
		private noteService: NoteService,
		private dataService: DataService,
		private cookieService: CookieService,
		private displayService: DisplayService,
		private validationService: ValidationService,
		private tabService: TabService,
		private settingsService: SettingsService,
		private dataTableService: DataTableService,
		private envService : EnvService
	) {
		this.emailPattern = this.validationService.getPattern('email');

		this.checkCookies();
	}

	// TABBING METHODS

	getActiveTab(tabsData): any {
		let activeTab = {};
		tabsData.forEach(function (d, i) {
			if (d.active) {
				activeTab = d;
			}
		});
		return activeTab;
	}

	tabClick(event, tabProp, tabsData, type) {
		console.log('TAB CLICK', event, tabProp, tabsData);
		const self = this;
		tabsData.forEach(function (d, i) {
			d.active = false;
			if (d.prop === tabProp) {
				d.active = true;
				console.log('ACTIVATE TAB', d);
				if (d.listTab) {
					switch (d.type) {
						case 'standard':
							self.loadUsersForTab(d);
							break;
						case 'upload':
							self.updatePageDataForTab(d);
							break;
					}
				}
			}
		});
	}

	selectDefaultTab(tabsData) {
		const self = this;
		tabsData.forEach(function (d, i) {
			tabsData[i].active = false;
			tabsData[i].cached = false;
		});
		let foundDefault = false;
		let defaultIndex = -1;
		tabsData.forEach(function (d, i) {
			console.log('CHECK TAB FOR DEFAULT', d, self.tabService.showTab(d.persona, d.notPersona));
			if (self.tabService.showTab(d.persona, d.notPersona) && !foundDefault) {
				foundDefault = true;
				defaultIndex = i;
				if (d.listTab) {
					switch (d.type) {
						case 'standard':
							self.loadUsersForTab(d);
							break;
						case 'upload':
							self.updatePageDataForTab(d);
							break;
					}
				}
			}
		});
		tabsData[defaultIndex].active = true;
		console.log('SELECTED DEFAULT TAB', tabsData);
	}

	selectActiveTab(tabsData, tabProp) {
		const self = this;
		tabsData.forEach(function (d, i) {
			d.active = false;
			if (d.prop === tabProp) {
				d.active = true;
				console.log('ACTIVATE TAB', d);
				switch (d.type) {
					case 'standard':
						self.loadUsersForTab(d);
						break;
					case 'upload':
						self.updatePageDataForTab(d);
						break;
				}
			}
		});
	}

	showTabSearch(tabsData) {
		this.getActiveTab(tabsData)['searching'] = !this.getActiveTab(tabsData)['searching'];
	}

	checkTabs(tabsData) {
		// expected method, no logic needed for po page tabs
		// see same method in contractorService for example of use
	}

	loadAllforTab(tab) {
		if (tab.listTab) {
			this.loadUsersForTab(tab, true);
		}
	}

	loadUsersForTab(tab, loadAll = false) {
		console.log('LOAD USERS FOR TAB', tab);
		this.loadUsers(tab, loadAll);
	}

	updatePageDataForTab(tab) {
		const dataRef = this.uploadDataObj + '-' + tab.prop + '-' + tab.type;
		let users = [];
		const self = this;
		switch (tab.prop) {
			case 'valid':
				users = self.fileUploadedUsers;
				break;
			case 'invalid':
				users = self.fileUploadedInvalidUsers;
				break;
		}
		const bIdx = tab.page * this.uploadPageSize;
		const eIdx = (tab.page + 1) * this.uploadPageSize >= users.length ? users.length : (tab.page + 1) * this.uploadPageSize;
		this.dataService.updatePageData(dataRef, tab, users.slice(bIdx, eIdx));
		this.dataService.updateDataCount(dataRef, users.length);
	}

	// UI INTERACTIONS
	openUser(data) {
		this.dataService.updateUser(data);
		this.router.navigateByUrl(this.objRoot);
	}

	tableClick(event) {
		console.log('USER TABLE CLICK: ', event);
		const clickedRow = event.row;
		this.openUser(clickedRow);
	}

	tableSelect(event) {
		console.log('USER TABLE SELECT: ', event, this.dataService.selectedTableRows);
		// for some reason this.dataService.selectedTableRows is not updated by select all
		this.dataService.selectedTableRows = event.selected;
	}

	tableRefresh(event) {
		console.log('PO TABLE REFRESH: ', event);
		const activeTab = this.getActiveTab(this.tabsData.listTabs);
		this.loadUsersForTab(activeTab);
	}

	tablePage(event) {
		const activeTab = this.getActiveTab(this.tabsData.listTabs);
		this.getActiveTab(this.tabsData.listTabs)['page'] = event.offset;
		this.loadUsersForTab(activeTab);
	}

	tableSort(event) {
		this.dataTableService.tableSort(event, this.getActiveTab(this.tabsData.listTabs), (tab) => this.loadUsersForTab(tab));
	}

	tableSearch(event) {
		console.log('USER TABLE SEARCH: ', event);
		const activeTab = this.getActiveTab(this.tabsData.listTabs);
		this.loadUsersForTab(activeTab);
	}

	uploadTablePage(event) {
		console.log('USER TABLE PAGE: ', event);
		const activeTab = this.getActiveTab(this.tabsData.uploadTabs);
		this.getActiveTab(this.tabsData.uploadTabs)['page'] = event.offset;
		this.updatePageDataForTab(activeTab);
	}

	isContractor() {
		let isContractor = false;
		if (this.persona.toLowerCase() === 'contractor') {
			isContractor = true;
		}
		return isContractor;
	}

	isPM() {
		let isPM = false;
		if (this.persona.toLowerCase() === 'pm') {
			isPM = true;
		}
		return isPM;
	}

	isSAM() {
		let isSAM = false;
		if (this.persona.toLowerCase() === 'sam') {
			isSAM = true;
		}
		return isSAM;
	}

	getToken() {
		return this.token;
	}

	getRoleText(roleCode: string) {
		const result = this.configService.roles.filter(role => role.id === roleCode);
		return result[0].itemName;
	}

	setToken(token) {
		console.log('SET TOKEN', token);
		this.token = token;
		this.commsService.token = token;
		this.cookieService.set('token', token, 99999999999999999, '/');
	}
	setRefreshToken(token) {
		console.log('SET REFRESH TOKEN', token);
		this.dataService.refreshToken = token;
	}

	/**
	 * sets persona property in all services that will use it.
	 * optionally, set available personas for users with multiple roles
	 */
	setPersona(persona: string, availablePersonas: string[] = undefined): void {
		console.log('SET PERSONA', persona, availablePersonas);
		this.configService.personas.forEach((d, i) => {
			if (persona === d.prop) {
				this.configService.personaIndex = i;
			}
		});
		this.persona = persona;
		this.selectedPersona = persona;
		this.configService.persona = persona;
		this.commsService.persona = persona;
		this.cookieService.set('persona', persona, 99999999, '/');
		// save available personas so multiple persona options are remembered after a refresh
		if (availablePersonas) {
			this.availablePersonas = availablePersonas;
			// join array with a dash, commas are not allowed in cookies
			this.cookieService.set('availablepersonas', availablePersonas.join('-'), 99999999, '/');
		}
	}

	/**
	 * Switch to a user's other persona (for users with 2 personas)
	 */
	switchPersona(): void {
		this.choosePersona(this.getAlternatePersona());
	}

	/**
	 * If a user has multiple personas, return the one that is not currently selected.
	 * For now there are only users with 2 personas, so if more are needed, this will need to be updated.
	 */
	getAlternatePersona(): string|undefined {
		if (this.availablePersonas.length > 1) {
			return this.availablePersonas.find(x => x !== this.selectedPersona);
		}
	}

	setUserSettings(userSettings) {
		console.log('SET USER SETTINGS', userSettings);
		if (userSettings) {
			this.dataService.updateUserSettings(JSON.parse(userSettings));
		}
	}

	/**
	 * Find full name of persona. If persona argument is not given, find current persona
	 */
	getFullPersona(persona: string = undefined): string {
		persona = persona ? persona : this.persona;
		let fullPersona = persona;
		this.configService.personas.forEach((d) => {
			if (d.prop === persona) {
				fullPersona = d.name;
			}
		});
		return fullPersona;
	}

	getPersona() {
		return this.persona;
	}

	setAuth() {
		this.dataService.auth = true;
		this.loadUsersByPersona(this.configService.validateSAMProp);
		this.loadUsersByPersona(this.configService.validatePMProp);
		this.loadUsersByPersona(this.configService.validateTRAProp);
		this.settingsService.loadUserSettings();
		this.loadZeroConfigs();
		this.dataService.broadcastNotifications('init');
	}

	removeAuth() {
		this.cookieService.deleteAll('/');
		this.cookies = this.cookieService.getAll();
		this.dataService.clearData();
		console.log('REMOVE AUTH', this.cookies);
		if (this.dataService.isLoggingInWithSSO) {
			this.dataService.isLoggingInWithSSO = false;
			console.log('REMOVE SSO AUTH');
			let ssoLogoutWindow;
			if (this.username.trim().toLowerCase().endsWith('ibm.com')) {
				ssoLogoutWindow = window.open(this.envService.getLogoutUrl());
			}else{
				ssoLogoutWindow = window.open(this.envService.getIbmid_Logout_url());
			}
			setTimeout(() => {
				ssoLogoutWindow.close();
			}, 4000);
		}
		
	}

	/**
	 * check existing cookies and use them to set personas and tokens
	 */
	checkCookies(): void {
		this.cookies = this.cookieService.getAll();
		console.log('CHECK COOKIES:', this.cookies);
		if (this.cookies['persona'] && this.cookies['token']) {
			// pass in persona (and 'available personas' if available)
			this.setPersona(
				this.cookies['persona'],
				this.cookies['availablepersonas'] ? this.cookies['availablepersonas'].split('-') : undefined);
			this.setToken(this.cookies['token']);
			this.setRefreshToken(this.cookies['refreshToken']);
			this.setAuth();
		}
	}

	// AUTOMATED PROCESSES

	directUser() {
		this.getPersonaPath(this.persona);
	}

	/**
	 * route user to the default path for their persona
	 */
	getPersonaPath(persona): void {
		let personaPath = '';
		this.configService.personas.forEach(function (d, i) {
			if (d.prop === persona) {
				personaPath = d.path;
			}
		});

		if (personaPath === 'dashboard' && persona === this.configService.personaProps.contractor) {
			// need validate contractor and display the appropriate message if he is not ready to use app
			this.commsService.getUserKeys().subscribe((res) => {
				const jsonRes = res.detail;
				console.log('LOAD USER KEYS RES: ', jsonRes);
				// non-approved contractor will get empty detail
				if (jsonRes && jsonRes.length > 0) {
					const activePOs = jsonRes.filter(json => {
						return json.po && !json.po.cancellation;
					});
					if (activePOs.length === 0) {
						this.dataService.landingPageMessage =
							'Load timesheet error. No active PO found. Please reach out to your Manager.';
					} else {
						if (jsonRes.length > 1) { // need sort PO actualenddate by descending
							jsonRes.sort((a, b) => {
								if (a.actualenddate < b.actualenddate) {
									return 1;
								}
								if (a.actualenddate > b.actualenddate) {
									return -1;
								}
								return 0;
							});
						}
						const poNumber = jsonRes[0][this.configService.poNumberProp];
						this.configService.supplierId = jsonRes[0][this.configService.supplierIdProp];
						this.dataService.setUserKeys(jsonRes);
						this.dataService.selectedPO = null;
						// if contractor has more than one POs, need build a jason to map ponumber to its poObject
						if (jsonRes.length > 1) {
							this.dataService.setContractorSelectedPO();
							if (this.dataService.selectedPO) {
								this.supplierId = this.dataService.userKeys[this.dataService.selectedPO.prop][this.configService.supplierIdProp];
							}
						} else {
							this.dataService.selectedPO = {
								name: poNumber,
								prop: poNumber
							};
						}
						this.router.navigateByUrl(personaPath);
					}
				} else {
						this.dataService.landingPageMessage =
							'Your contractor record has not been approved yet. You will receive an email when your contractor record is fully approved. Please reach out to your manager if you have any questions.';
						this.router.navigateByUrl('home');
				}
			}, (err) => {
				this.router.navigateByUrl('home');
				if (err && err.error && err.error.message) {
						this.noteService.displayError(err.error.message);
				}
			});
		} else {
			console.log('PERSONA PATH', personaPath);
			this.dataService.setUserKeys([]);
			this.router.navigateByUrl(personaPath);
		}
	}


	sendSSOLogin(code, redirectURI) {
		// clean local cache
		this.displayPrivacyNotice = false;
		this.agreedForPrivacy = false;

		this.dataService.isLoggingInWithSSO = true;
		this.commsService.ssoLoginUser(code, redirectURI, localStorage.getItem(this.configService.ssoCompanyProp)).subscribe(res => {
			const user = res;
			console.log('LOGIN USER RES: ', user);

			localStorage.removeItem(this.configService.ssoCompanyProp);
			this.setToken(user.accessToken);
			this.setRefreshToken(user.refreshToken);
			this.email = user.email;
			this.username = user.email;
			this.configService.username = user.email;
			this.showReleaseNotes = user.showrelease;
			this.checkPersonasAndAgreedForPrivacy(user.persona, user.isagreedforprivacy);
		}, (err) => {
			this.dataService.isLoggingInWithSSO = false;
			this.removeAuth();
			localStorage.removeItem(this.configService.ssoCompanyProp);

			if (err.error.message === 'Invalid email/password') {
				this.noteService.displayError(
					'Invalid email/password',
					false,
					[{ text: 'login help', callback: () => this.router.navigateByUrl('login-help') }]);
			} else {
				this.commsService.handleAPIError('Login', err, true);
			}
		});
	}

	getSSOLoginURL(redirectURI) {
		const  ssoURLs = {
			IBM: `${this.envService.getAuthorizationUrl()}?client_id=${this.envService.getClientId()}&scope=openid&response_type=code&redirect_uri=${redirectURI}`,
		};
		return ssoURLs;
	}

	getIBMIdLoginURL(redirectURI) {
		const  ibmidURLs = {
			NonIBM: `${this.envService.getIbmid_Authorization_Url()}?client_id=${this.envService.getIbmid_Client_id()}&scope=openid&response_type=code&redirect_uri=${redirectURI}`,
		};
		return ibmidURLs;
	}

	checkPersonasAndAgreedForPrivacy(personas, agreedForPrivacy) {
		if (personas) {
			if (personas.includes(',')) {
				this.availablePersonas = personas.split(',');
				this.selectedPersona = this.availablePersonas[0];
				this.dataService.selectPersona = true;
				this.agreedForPrivacy = agreedForPrivacy;
			} else {
				this.setPersona(personas);
				if (agreedForPrivacy) {
					localStorage.setItem(localStorageKeys.needRunTSTourGuide, 'false');
					this.setAuth();
				} else {
					this.displayPrivacyNotice = true;
					localStorage.setItem(localStorageKeys.needRunTSTourGuide, 'true');
				}
			}
		}
	}

	onPasswordReset(reset, forgot = false) {
		this.isForgotPassword = forgot;
		this.isResetPassword = reset;
		this.noteService.clearCurrentNote();
	}

	uploadUsers(files) {
		// this.cancleAddUser();
		// const files = input.files;
		this.isManualAdd = false;
		this.fileUploadedUsers = [];
		this.fileUploadedInvalidUsers = [];
		this.files = files;
		const reader = new FileReader();
		const users = [];
		const invalidUsers = [];
		// get valid role ids for the persona
		this.validRoles = this.getRoleIDsByPersona();

		const self = this;
		if (!files || !files[0].name.endsWith('.csv')) {
			self.fileUploadMessage = 'Error processing file. The file must be a csv (comma separated values) file with the extension of .csv';
			self.fileUploadSuccessMessage = '';
			return;
		}
		reader.readAsText(files[0]);
		reader.onload = (e: any) => {
			const res = reader.result.toString().split(/\r?\n/);
			if (!res) {
				self.fileUploadMessage = 'Error processing file. The file must be in the format of csv(comma separated values)';
				self.fileUploadSuccessMessage = '';
			} else {
				const lineOne = res[0].split(',');
				if (lineOne && lineOne[0].trim().toLowerCase() === 'email' && lineOne[1].trim().toLowerCase() === 'role') {
					for (let i = 1; i < res.length; i++) {
						let line = [];
						// line = res[i].match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g);
						line = res[i].match(/"[^"]*"|[^",\s]+/g);
						if (line && line.length > 0) {
							if (res[i].match(/^,/)) {
								line.unshift('');
							}
							const user = { email: '', role: '', rolename: '' };
							if (line[0]) {
								user.email = line[0].trim();
							}
							if (line[1]) {
								user.role = line[1].toLowerCase().trim().replace(new RegExp('"', 'g'), '');
								user.role = user.role.replace(/mgr/gi, 'pm');
								user.role = user.role.replace(/dtv/gi, 'tra');
								user.rolename = this.configService.getRolenameById(user.role);
							}
							const fomattedUser = this.validateUploadUser(user);
							if (fomattedUser) {
								users.push(fomattedUser);
							} else {
								invalidUsers.push(user);
							}
						} else {
							continue;
						}
					}
					self.fileUploadedUsers = users;
					self.fileUploadedInvalidUsers = invalidUsers;
					self.fileUploadSuccessMessage = 'File upload Successfully';
					self.fileUploadMessage = '';
					self.selectDefaultTab(self.tabsData.uploadTabs);
				} else {
					// self.isSuccessfulUpload = false;
					// eslint-disable-next-line max-len
					self.fileUploadMessage = 'Error processing file. The file must be a csv file(comma separated values) and the first line should only contain "email" and "role" as headers';
					self.fileUploadSuccessMessage = '';
				}
			}
		};
		reader.onerror = (e: any) => {
			console.log(e.target.result);
			self.fileUploadMessage = 'Error processing file. The file must be a csv file(comma separated values)';
			self.fileUploadSuccessMessage = '';
		};
	}

	validateUploadUser(user) {
		// email and role both need be filled
		if (!user.email || !user.role) {
			return null;
		}

		// check email validation
		if (user.email && user.email.length > 0) {
			const matched = user.email.match(this.emailPattern);
			if (!matched) {
				return null;
			}
		}

		// check role validation
		if (user.role && user.role.length > 0) {
			const role = user.role.trim();
			if (role.indexOf(',') === 0) {
				return null;
			} else if (role.indexOf(',') > 0) {	// check if the combined roles are supported by persona
				const rolesArr = role.split(',');
				if (!this.validRoles.includes(rolesArr[0].trim() + ',' + rolesArr[1].trim()) &&
					!this.validRoles.includes(rolesArr[1].trim() + ',' + rolesArr[0].trim())) {
					return null;
				} else {
					user.role = rolesArr[0].trim() + ',' + rolesArr[1].trim();
				}
			} else {
				if (!this.validRoles.includes(user.role)) {	// check if the single role is supported by persona
					return null;
				}
			}
		}
		return user;
	}

	resetAddUsers() {
		this.isManualAdd = true;
		this.fileUploadMessage = '';
		this.fileUploadSuccessMessage = '';
		this.fileUploadedUsers = [];
	}

	getRoleIDsByPersona() {
		const roleIDs = [];
		const self = this;
		this.configService.getRolesByPersona().forEach(role => {
			roleIDs.push(role.id);
		});
		return roleIDs;
	}

	editableRoles() {
		const self = this;
		const roles = this.configService.roles;
		const editableRoles = [];
		roles.forEach(function (d, i) {
			if (d.canEdit === self.persona) {
				editableRoles.push(d);
			}
		});
		return editableRoles;
	}

	handlePartialSuccess(res) {
		const self = this;
		const error = res.error;
		self.showFailedUsers = false;
		self.showSuccessUsers = false;

		self.configService.resetTempTab();
		const tempTab = self.configService.tempTab;

		const errorRes = self.commsService.getPartialError(error);
		const errorCount = self.commsService.getSuccessCount(errorRes);
		const errorDataRef = self.errorDataObj + '-' + tempTab.prop + '-' + tempTab.type;
		self.dataService.updatePageData(errorDataRef, tempTab, errorRes);
		self.dataService.updateDataCount(errorDataRef, errorCount);

		const successRes = self.commsService.getPartialSuccess(error);
		const successCount = self.commsService.getSuccessCount(successRes);
		const successDataRef = self.successDataObj + '-' + tempTab.prop + '-' + tempTab.type;
		self.dataService.updatePageData(successDataRef, tempTab, successRes);
		self.dataService.updateDataCount(successDataRef, successCount);

		self.showFailedUsers = true;
		if (this.dataService.pageData[successDataRef][0].length > 0) {
			this.showSuccessUsers = true;
		}
	}

	//
	// API CALLS
	//

	/**
	 * For users with multiple roles, this makes an API call to choose their role.
	 * After success, tokens and personas are set.
	 */
	choosePersona(role): void {
		if (role) {
			this.commsService.persona = role;
			this.commsService.loginRole(role).subscribe((res) => {
				console.log('CHOOSE PERSONA RES: ', res);

				const successData = res;
				this.setPersona(successData.persona, this.availablePersonas);
				this.setToken(successData.accessToken);
				if (this.agreedForPrivacy) {
					this.setAuth();
				} else {
					this.displayPrivacyNotice = true;
				}
				// broadcast user settings, since changing personas effectively changes the user
				this.dataService.broadcastUserSettings();
				// route to the persona's path, in case a new persona has a different default page
				this.getPersonaPath(successData.persona);
			}, (err) => {
				this.removeAuth();
				this.commsService.handleAPIError('Choose Persona', err);
			});
		}
	}

	sendLogin(username: string, password: string): void {
		this.username = username;
		// clean local cache
		this.displayPrivacyNotice = false;
		this.agreedForPrivacy = false;
		this.dataService.isLoggingInWithSSO = false;
		this.displayService.startLoading();

		this.commsService.loginUser(username, password).subscribe((res) => {
			console.log('LOGIN USER RES: ', res);

			const successData = res;
			this.email = successData.email;
			this.persona = successData.persona;
			this.setToken(successData.accessToken);
			this.setRefreshToken(successData.refreshToken);
			if (successData.isagreedforprivacy) {
				this.agreedForPrivacy = true;
			}
			this.showReleaseNotes = successData.showrelease;

			// SUBSEQUENT ACTIONS
			const personas = successData.persona;
			this.checkPersonasAndAgreedForPrivacy(personas, successData.isagreedforprivacy);
			this.noteService.clearCurrentNote(true);
			this.triggerLoginActions(successData);
			this.displayService.endLoading();

		}, (err) => {
			console.log('LOGIN USER ERROR: ', err);
			this.removeAuth();

			// if error reason is because of an expired password, then redirect to the change password page
			if (err.error.message?.startsWith('Your password has expired')) {
				this.isResetPassword = true;
			}

			if (err.error.message === 'Invalid email/password') {
				this.noteService.displayError(
					'Invalid email/password',
					false,
					[{ text: 'login help', callback: () => this.router.navigateByUrl('login-help') }]);
			} else {
				this.commsService.handleAPIError('', err);
			}

			this.displayService.endLoading();
		});
	}

	triggerLoginActions(successData) {
		const numDaysPasswordExpirationWarning = 7;
		// if expiration date minus 7 days is less than current date, show expiration warning
		const expirationDate = new Date(successData.passwordExpiration).getTime();
		const timePeriod = (numDaysPasswordExpirationWarning * 24 * 60 * 60 * 1000);
		if ((expirationDate - timePeriod) < Date.now()) {
			setTimeout(() => this.noteService.displayWarning(`Your password will expire on ${successData.passwordExpiration}`, false, [{
				text: 'Change Password',
				callback: () => this.router.navigateByUrl('reset-password')
			}]), 1000);
		}
	}

	loadUsersByPersona(persona) {
		const self = this;

		this.commsService.getUsersByPersona(persona).subscribe((res) => {
			console.log('LOAD USERS RES: ', persona, res);

			const successData = self.commsService.getSuccessData(res);
			const users = [];
			successData.forEach(function (d, i) {
				users.push(d);
			});
			self.dataService.updateUsers(persona, users);

		}, (err) => {
			self.commsService.handleAPIError('Load ' + persona + ' Users', err);
		});
	}

	loadZeroConfigs() {
		const self = this;

		this.displayService.startLoading();
		this.commsService.getZeroConfigs().subscribe((res) => {
			self.displayService.endLoading();
			console.log('LOAD ZERO CONFIGS RES: ', res);
			const successData = self.commsService.getSuccessValue(res);
			if (successData) {
				self.dataService.updateZeroConfigs(successData);
			}
		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('Load Zero Configs', err);
		});
	}


	loadUsers(data, loadAll = false) {
		console.log('LOAD USERS', data, loadAll);
		const self = this;

		if (!loadAll) {
			// this.displayService.startLoading();
			this.displayService.activateLoadingTab(data, this.tabsData.listTabs);
		}
		this.commsService.getUsers(data, loadAll).subscribe((res) => {
			console.log('LOAD All USERS RES: ', res);
			if (!loadAll) {
				// self.displayService.endLoading();
				this.displayService.deactivateLoadingTab(data, this.tabsData.listTabs);
			}

			const successData = self.commsService.getSuccessData(res);
			const count = self.commsService.getSuccessCount(res);
			const users = _.cloneDeep(successData);
			users.forEach(function (d, i) {
				if (d.status === 0) {
					d.status = 'revoked';
				} else {
					d.status = 'active';
				}
				// convert role to name
				d.rolename = self.configService.getRolenameById(d.role);
				d.expirationdate = self.dataService.formatDateTime(d.expirationdate);
			});
			if (!loadAll) {
				const dataRef = self.dataObj + '-' + data.prop + '-' + data.type;
				self.dataService.updatePageData(dataRef, data, users);
				self.dataService.updateDataCount(dataRef, count);
			} else {
				self.dataService.broadcastLoadAll(users);
			}
		}, (err) => {
			if (!loadAll) {
				// self.displayService.endLoading();
				this.displayService.deactivateLoadingTab(data, this.tabsData.listTabs);
			}
			self.commsService.handleAPIError('Load Users', err);
		});
	}

	createUsers(users) {
		const self = this;

		// end spinner if no response with 30s
		// prevent normal handling if timedout
		let timeout = true;
		let timedout = false;
		const delay = setTimeout(function () {
			if (timeout) {
				self.displayService.endLoading();
				timedout = true;
				self.noteService.displayInfo('User(s) creation is still in progress.  Please check back.');
			}
		}, this.commsService.timeout * 1000);

		this.displayService.startLoading();
		this.commsService.createUsers(users).subscribe((res) => {
			timeout = false;
			if (!timedout) {
				self.displayService.endLoading();
				console.log('CREATE USER RES: ', res);

				const successData = self.commsService.getSuccessData(res);
				if (res.status === self.configService.partialString) {
					self.noteService.displayError('Some user(s) failed creation.');
					self.handlePartialSuccess(res);
				} else {
					self.noteService.displaySuccess('The user(s) has been successfully created.');
				}

				// SUBSEQUENT ACTIONS
				self.selectDefaultTab(self.tabsData.listTabs);
			}
		}, (err) => {
			console.log('CREATE USER ERROR RESPONSE', err);
			timeout = false;
			if (!timedout) {
				self.displayService.endLoading();
				// always use partial table so reason can be displayed with each error
				// if (err.json().status === self.configService.partialString) {
				self.noteService.displayError('Some user(s) failed creation.');
				self.handlePartialSuccess(err);
				// } else {
				// 	self.commsService.handleAPIError('Create Users', err);
				// }
			}
		});
	}

	revokeUsers(data) {
		const self = this;

		this.displayService.startLoading();
		this.commsService.revokeUsers(data).subscribe((res) => {
			self.displayService.endLoading();
			console.log('REVOKE USERS RES: ', res);

			self.showRemoveModal = false;
			const successData = self.commsService.getSuccessData(res);
			if (res.status === 'ERROR') {
				self.handlePartialSuccess(res);
			} else if (res.status === self.configService.partialString) {
				self.noteService.displayError('Some user(s) failed removal.');
				self.handlePartialSuccess(res);
			} else {
				self.noteService.displaySuccess('The selected users have been removed successfully.');
			}

			// SUBSEQUENT ACTIONS
			// self.loadAllUsers();
			// self.loadExpiringUsers();
			this.dataService.clearSelectedTableRows();
			this.selectDefaultTab(this.tabsData.listTabs);

		}, (err) => {
			self.displayService.endLoading();
			self.showRemoveModal = false;
			self.commsService.handleAPIError('Remove Users', err);
		});
	}

	revalidateUsers(data) {
		const self = this;

		this.displayService.startLoading();
		this.commsService.revalidateUsers(data).subscribe((res) => {
			self.displayService.endLoading();
			console.log('REVALIDATE USER RES: ', res);

			const successData = self.commsService.getSuccessData(res);
			if (res.status === self.configService.partialString) {
				self.noteService.displayError('Some user(s) failed revalidation.');
				self.handlePartialSuccess(res);
			} else {
				self.noteService.displaySuccess('The selected users have been revalidated successfully.');
			}

			// SUBSEQUENT ACTIONS
			// self.loadExpiringUsers();
			this.selectDefaultTab(this.tabsData.listTabs);

		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('Remove Users', err);
		});
	}

	sendPassword(data) {
		const self = this;

		this.displayService.startLoading();
		this.commsService.submitPassword(data).subscribe((res) => {
			self.displayService.endLoading();
			self.noteService.displaySuccess('Your password has been set.');
			console.log('SEND PASSWORD RES: ', res);

			const delay = setTimeout(function () {
				self.removeAuth();
				self.router.navigateByUrl('');
				self.noteService.clearCurrentNote();
			}, 1500);

		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('', err);
		});
	}

	changePassword(data) {
		const self = this;

		this.displayService.startLoading();
		this.commsService.resetPassword(data).subscribe((res) => {
			self.displayService.endLoading();
			self.noteService.displaySuccess('Your password has been changed successfully.');
			console.log('CHANGE PASSWORD RES: ', res);
			this.router.navigateByUrl('');
			setTimeout(()=>{this.onPasswordReset(false);}, 6000);

		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('', err);
		});
	}

	forgotPassword(data) {
		const self = this;

		this.displayService.startLoading();
		this.commsService.forgotPassword(data).subscribe((res) => {
			self.displayService.endLoading();
			self.noteService.displayInfo('You will receive an email when your request is approved.');
			console.log('FORGOT PASSWORD RES: ', res);
			setTimeout(()=>{this.onPasswordReset(false);}, 6000);

		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('', err);
		});
	}

	submitUserEdits(origin) {
		const self = this;
		const userDetails = this.dataService.userDetails;

		if (userDetails['status'] === 'revoked') {
			userDetails['status'] = 0;
		} else {
			userDetails['status'] = 1;
		}

		console.log('SUBMIT USER EDITS', userDetails);

		this.displayService.startLoading();
		this.commsService.sendUserEdits(userDetails).subscribe((res) => {
			self.displayService.endLoading();
			self.noteService.displaySuccess('The user edits have been submitted successfully.');
			console.log('SEND USER EDITS RES: ', res);

			const successData = self.commsService.getSuccessData(res);
			origin.userSuccess();

		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('Submit User Edits', err);
		});
	}

	getShowReleaseNotes() {
		// should only return true once and then be set to false, so it doesn't keep displaying every time it reloads
		if (this.showReleaseNotes) {
			this.showReleaseNotes = false;
			return true;
		}
		return false;
	}

	formatUserName(userName, isLowerCase = true) {
		if (!userName) {
			return '';
		} else if (isLowerCase) {
			return userName.trim().toLowerCase();
		} else {
			return userName.trim().toUpperCase();
		}
	}

	canAccessCal() {
		let canAccessCal = false;
		try {
			this.dataService.invoiceCalendars.forEach((cal) => {
				if (cal.id === this.dataService.poDetails[this.configService.calendarIdProp]) {
					canAccessCal = true;
				}
			});
		} catch (e) {}

		const persona = this.persona.toLowerCase();
		if (persona !== 'sam') {
			canAccessCal = true;
		}

		return canAccessCal;
	}
}
